export const mapStates = list => {
	return list.map(({code, name}) => {
		return {
			value: code,
			label: name
		}
	});
}
